import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Trans } from '@lingui/react';
import { t } from '@lingui/macro';
import { useLocalisation } from '@3plearning/lingui-cdn';

// Components
import Checkbox, { LABEL_STYLES } from '../checkbox/checkbox';
import RadioButton from '../radio-button/radio-button';

export const MOVE_VALUE = 'move';
export const COPY_VALUE = 'copy';

function AddStudentsListBody(props) {
    const { i18n } = useLocalisation();
    // Props
    const {
        userId,
        index,
        fullName,
        groupName,
        classValue,
        isVisible,
        isDisabled,
        checkboxHandler,
        isSelected,
        moveCopyHandler
    } = props;

    const [actionType, setActionType] = useState(MOVE_VALUE);

    const selectIndividualStudent = () => {
        const localActionType = !isSelected ? actionType : undefined;
        checkboxHandler(userId, localActionType);
    };
    const radioButtonHandler = (e) => {
        const moveValue = e.target.value;
        setActionType(moveValue);
        moveCopyHandler(userId, moveValue);
    };
    const listOfButtons = [
        { name: i18n._(t`Add Modal - actions move`), value: MOVE_VALUE },
        { name: i18n._(t`Add Modal - actions copy`), value: COPY_VALUE }
    ];

    // Reset actionType value to be back to Move
    useEffect(() => {
        setActionType(MOVE_VALUE);
    }, [isSelected]);

    const className = classValue.map((item) => {
        let classId = 'classes'.concat(item);
        classId = classId.concat(userId);
        return <li key={classId}>{item}</li>;
    });

    let groupId = 0;
    const groupNameValue = groupName.map((item) => {
        groupId += 1;
        return <li key={groupId}>{item}</li>;
    });

    return isVisible ? (
        <tr
            className={`table__row ${isSelected ?
                'table__row--selected' : ''} ${isDisabled ? 'table__row--disabled' : ''}`}>
            <td className="table__cell table__cell--checkbox">
                <Checkbox
                    uid={`a-${userId}`}
                    isChecked={isSelected}
                    isDisabled={isDisabled}
                    callback={selectIndividualStudent}
                    labelText={`${fullName}-${index}`}
                    inputType={LABEL_STYLES.hidden} />
            </td>
            <td className="table__cell table__cell--add-student">
                <span title={fullName} className="text-ellipsis">{fullName}</span>
            </td>
            <td className="table__cell">
                <ul>{className}</ul>
            </td>
            <td className="table__cell">
                <ul>{groupNameValue}</ul>
            </td>
            <td className="table__cell">
                <span className="sr-only" id={`add-action-${userId}`}>
                    <Trans id={'Add Modal - action to perform for - {fullName}'}>
                        1 {fullName}
                    </Trans>
                </span>
                <RadioButton
                    id={`add-actions-${userId}`}
                    groupName={`add-actions-${fullName}-${userId}-${isSelected}`}
                    ariaProps={{
                        'aria-describedby': `add-action-${userId}`
                    }}
                    value={actionType}
                    isDisabled={!isSelected}
                    listOfButtons={listOfButtons}
                    changeHandler={radioButtonHandler}
                />
            </td>
        </tr>
    ) : (
        <tr />
    );
}

AddStudentsListBody.propTypes = {
    userId: PropTypes.number,
    index: PropTypes.number,
    fullName: PropTypes.string,
    groupName: PropTypes.array,
    classValue: PropTypes.array,
    moveCopyHandler: PropTypes.func,
    checkboxHandler: PropTypes.func,
    isVisible: PropTypes.bool,
    isSelected: PropTypes.bool,
    isDisabled: PropTypes.bool
};

export default AddStudentsListBody;



// WEBPACK FOOTER //
// ./components/students-lists/add-students-list-body.js